/* eslint-disable max-len */
/* eslint-disable no-return-assign */
import { useEffect, useState, useMemo } from 'react';
import * as clientApi from '../../../api/clients';
import { COMPANY } from '../../../constants';
import { getGroupedData, convertStructure } from '../utils/convertData';

export default function useSearch(query, entity, pageNumber) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [clients, setClients] = useState([]);
  const [totalPages, setTotalPages] = useState(null);

  const groupedClients = useMemo(() => getGroupedData(clients), [clients, getGroupedData]);

  useEffect(() => {
    setClients([]);
  }, [query, entity]);

  const getTotalPages = async () => {
    if (!totalPages) {
      const newToTalPages = await clientApi.getClientsEntityAssignedPageSize(COMPANY, entity, 25);
      setTotalPages(newToTalPages);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    setError(false);
    try {
      await getTotalPages();
      const clientsData = await clientApi.getClientsEntityAssigned(COMPANY, entity, query, pageNumber);
      const newClientsData = await convertStructure(clientsData);
      setClients((prev) => [...prev, ...newClientsData]);
    } catch (e) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [query, entity, pageNumber]);

  return {
    loading,
    error,
    clients: groupedClients,
    totalPages,
    hasMore: pageNumber < totalPages,
  };
}
